import React from "react";
import { Alert, Button, Grid } from "@mui/material/";
import LoadingButton from "@mui/lab/LoadingButton";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { strings } from "../../../../../common/i18n";
import {
    ErrorThemeProvider,
    SuccessThemeProvider
} from "../../../../../common/styles/providers";
import styles from "../styles";

/**
 * Action  Components
 */

export default ({
    approved,
    readonly,
    rejected,
    displayRejection,
    data,
    loading,
    onApprove,
    onRejectHide,
    onRejectShow
}) => {
    if (data.status === 1) return <></>;
    if (data.status > 1 && data.isAssigned)
        return (
            <Grid container>
                <Grid item xs={6} sx={{ p: 2 }}>
                    <ErrorThemeProvider>
                        <LoadingButton
                            color="error"
                            disabled={approved && readonly}
                            sx={styles.buttonBorderRadius}
                            disableElevation={!displayRejection}
                            fullWidth
                            onClick={
                                displayRejection ? onRejectHide : onRejectShow
                            }
                            size="large"
                            variant={
                                rejected || displayRejection
                                    ? "outlined"
                                    : "contained"
                            }
                            loading={loading}
                        >
                            {displayRejection ? (
                                <ArrowDropUp sx={styles.iconLeft} />
                            ) : (
                                <ArrowDropDown sx={styles.iconLeft} />
                            )}
                            {strings(rejected ? "rejected" : "reject")}
                        </LoadingButton>
                    </ErrorThemeProvider>
                </Grid>
                <Grid item xs={6} sx={{ p: 2 }}>
                    <SuccessThemeProvider>
                        <LoadingButton
                            sx={styles.buttonBorderRadius}
                            color="primary"
                            disabled={readonly || approved}
                            disableElevation
                            fullWidth
                            onClick={onApprove}
                            size="large"
                            variant={approved ? "outlined" : "contained"}
                            loading={loading}
                        >
                            {strings(approved ? "approved" : "approve")}
                        </LoadingButton>
                    </SuccessThemeProvider>
                </Grid>
            </Grid>
        );
    else return <></>;
};
